import { writable } from "svelte/store";
import { firebase,functions } from "../firebase";
import db from "../firebase";
import { httpsCallable } from "firebase/functions";

// Invocar función
export async function enviarNotificacion(item) {
  const sendNotificacion = httpsCallable(functions, "enviarNotificacion");
  try {
  const result = await sendNotificacion(item);
    } catch (err) {
      console.log(`Error: ${err.message}`);
       ;
    }
}

export const document = writable({
  status: 200,
});

export const controllers = writable({
  viewsData: {
    ico: "components_dash/img-logo.png",
    name: "Eltecon",
    idServices: 0,
    status: 100,
    admins: [
      {
        email: "",
      },
    ],
    data: {},
  },
});

export const currentDate = (currentD) => {
  let currentDate = new Date(currentD);
  return `
    ${currentDate.getFullYear()} - ${String(
    currentDate.getMonth() + 1
  ).padStart(2, "0")} - ${String(currentDate.getDate()).padStart(2, "0")}`;
};

export const updateService = async () => {
  let services;
  let cont = 1;
  panelController.update((values) => {
    services = {
      collection: "service",
      id: values.firebase.docs[0].id,
      data: values.service,
    };
    return values;
  });

  let i = 1;

  do {
    i++;
    let statusDoc = await updateD(services);
    if (statusDoc.status) {
      i = false;
    }

    if (statusDoc.status === false) {
      alert(statusDoc.error);
    }

    if (i > 3) {
      i = false;
    }
  } while (i);
};

export function dataReset() {
  return {
    errores: {
      system: [{ error: "", date: "", dataSystem: {} }],
      apis: [{ error: "", date: "", dataSystem: {} }]
    },
    notificaciones: {
      index: 0,
      ToastList: [
        {
          status: false,
          data: {
            show: false,
            title: "",
            img: "",
            body: "",
            time: "ahora",
          },
        },
        {
          status: false,
          data: {
            show: false,
            title: "",
            img: "",
            body: "",
            time: "ahora",
          },
        },
        {
          status: false,
          data: {
            show: false,
            title: "",
            img: "",
            body: "",
            time: "ahora",
          },
        },
        {
          status: false,
          data: {
            show: false,
            title: "",
            img: "",
            body: "",
            time: "ahora",
          },
        },
        {
          status: false,
          data: {
            show: false,
            title: "",
            img: "",
            body: "",
            time: "ahora",
          },
        },
      ],
      timeoutID: [],
    },
    firebase: {
      valid: false,
      validAmin: false,
      load: false,
      docs: [
        { name: "service", id: "", status: false },
        {
          name: "rattings",
          id: "",
          ids: [{ ids: "", status: false, name: "" }],
        },
      ],
    },
    icons: {
      favicon: "/components_dash/dist/img/favicon ratingg.png",
      logoRatingg: "/components_dash/ratingg_logo.svg",
      ico: "/components_dash/img-logo.png",
      alt: "/components_dash/ratingg_logo.svg",
      userlogo: "",
    },
    service: {
      ico: "components_dash/img-logo.png",
      nameRatting: "",
      nameService: "",
      name: "",
      date: "",
      key: 0,
      service: {
        mode: 0,
        sub: false,
        super: false,
      },
      membresia: true /* rol: 0, */ /* admin,nuevo,muestra,login, colaborador ,  */,
      admins: [],
      listRatinggs: [
        {
          config: {
            id: "010610",
            name: "",
            date: "",
            login: true,
            key: [true, 0],
          },
          rattings: [{}],
        },
      ],
    },
    viewEvaluacion: {
      status: false,
      nav: false,
      controllers: {
        btn: [
          {
            text: "Guardar",
            status: false,
            style: "btn-success",
            opc: 1,
          },
          {
            text: "Siguiente",
            status: false,
            style: "btn-primary",
            opc: 2,
          },
        ],
        inputs: [
          {
            active: true,
            index: 0,
            value: "",
            valid: true,
            styletxt: "",
          },
        ],
      },
      index: [false, false],
    },

    viewLogin: {
      roluser: 0,
      user: "login",
      url: { id: "", key: "", status: null },
      status: false,
      nav: false,
      controllers: {
        txt: {
          description: "",
          date: "",
          mess: "Por favor inicia sesión en tu cuenta para empezar a enviar ratings:",
        },
        btn: [
          {
            text: "Sign in with Google",
            status: false,
            style: "btn-lg px-auto btn-primary py-2 w-100",
            opc: 1,
          },
          {
            text: "Continuar",
            status: false,
            style: "btn-lg px-auto btn-primary py-2 w-100",
            opc: 3,
          },
          {
            text: "Crear cuenta",
            status: false,
            style: "btn-lg px-auto btn-primary py-2 w-100",
            opc: 1,
          },
        ],
      },
    },
    viewDashboard: {
      status: false,
      nav: false,
      time: [],
      promTime: 0,
      tendMesas: {
        labels: [],
        datasets: [
          {
            label: "Mesas",
            fill: true,
            lineTension: 0.4,
            backgroundColor: "rgba(225, 204,230, .3)",
            borderColor: "rgb(205, 130, 158)",
            borderCapStyle: "butt",
            borderDash: [],
            borderDashOffset: 0.0,
            borderJoinStyle: "miter",
            pointBorderColor: "rgb(205, 130,1 58)",
            pointBackgroundColor: "rgb(255, 255, 255)",
            pointBorderWidth: 10,
            pointHoverRadius: 5,
            pointHoverBackgroundColor: "rgb(0, 0, 0)",
            pointHoverBorderColor: "rgba(220, 220, 220,1)",
            pointHoverBorderWidth: 2,
            pointRadius: 1,
            pointHitRadius: 10,
          },
        ],
      },

      charts: [
        {
          labels: [
            "Eating",
            "Drinking",
            "Sleeping",
            "Designing",
            "Coding",
            "Cycling",
            "Running",
          ],
          datasets: [
            {
              label: "My First Dataset",
              data: [65, 59, 90, 81, 56, 55, 40],
              fill: true,
              backgroundColor: "rgba(255, 99, 132, 0.2)",
              borderColor: "rgb(255, 99, 132)",
              pointBackgroundColor: "rgb(255, 99, 132)",
              pointBorderColor: "#fff",
              pointHoverBackgroundColor: "#fff",
              pointHoverBorderColor: "rgb(255, 99, 132)",
            },
            {
              label: "My Second Dataset",
              data: [28, 48, 40, 19, 96, 27, 100],
              fill: true,
              backgroundColor: "rgba(54, 162, 235, 0.2)",
              borderColor: "rgb(54, 162, 235)",
              pointBackgroundColor: "rgb(54, 162, 235)",
              pointBorderColor: "#fff",
              pointHoverBackgroundColor: "#fff",
              pointHoverBorderColor: "rgb(54, 162, 235)",
            },
          ],
        },
      ],
    },
    viewMainRatinggs: {
      status: false,
      nav: false,
      cards: [
        {
          inputs: [
            {
              name: "fecha",
              active: true,
              value: "",
              old: "",
              valid: false,
              styletxt: "",
              messtxt: "",
            },
            {
              name: "Nombre",
              active: true,
              value: "",
              old: "",
              valid: false,
              styletxt: "",
              messtxt: "",
            },
            {
              name: "mode",
              active: true,
              value: 0,
              old: "",
              valid: false,
              styletxt: "",
              messtxt: "",
            },
            {
              name: "login",
              active: true,
              value: false,
              old: "",
              valid: false,
              styletxt: "",
              messtxt: "",
            },
            {
              name: "key",
              active: true,
              value: false,
              old: "",
              valid: false,
              styletxt: "",
              messtxt: "",
            },
            {
              name: "pin",
              active: true,
              value: "",
              old: "",
              valid: false,
              styletxt: "",
              messtxt: "",
            },
            {
              name: "id",
              active: true,
              value: "",
              old: "",
              valid: false,
              styletxt: "",
              messtxt: "",
            },
            {
              name: "Solo encenta",
              active: true,
              value: "",
              old: "",
              valid: false,
              styletxt: "",
              messtxt: "",
            },
          ],
          btn: [
            {
              text: "Guardar",
              status: false,
              style: "btn-light",
            },
            {
              text: "Editar",
              status: false,
              style: "btn-light",
            },
            {
              text: "Cancelar",
              status: false,
              style: "btn-light",
            },
            {
              text: "Crear preguntas",
              status: false,
              style: "btn-light",
            },
            {
              text: "Compartir",
              status: false,
              style: "btn-light",
            },
          ],
        },
      ],
    },
    viewPanel: {
      status: false,
      nav: false,
      index: [0, 0],
    },
    viewMembresias: {

      status: false,
      btn: [
        {
          status: false,
          text: "Anterior",
        },
        {
          status: false,
          text: "Siguiente",
        },
      ],
      nav: false,
      index: [false, false],
      modalForm: {
        status: false,
        id: 0,
        value: null,
        resolve: null,
        reject: null,
        mostrar: () => {
          modalS.update((value) => {
            value.status = true;
            return value;
          });

          return new Promise((resolve, reject) => {
            modalS.update((value) => {
              value.resolve = resolve;
              value.reject = reject;
              return value;
            });
          });
        },

        confirmar: (item) => {
          modalS.update((value) => {
            value.resolve(item);
            value.status = false;
            return value;
          });
        },

        reset: () => {

          modalS.update((value) => {
            value = {
              status: false,
              id: 0,
              value: null,
              resolve: null,
              reject: null,
              mostrar: () => {
                modalS.update((value) => {
                  value.status = true;
                  return value;
                });

                return new Promise((resolve, reject) => {
                  modalS.update((value) => {
                    value.resolve = resolve;
                    value.reject = reject;
                    return value;
                  });
                });
              },
              reset: value.reset,
              confirmar: (item) => {
                modalS.update((value) => {
                  value.resolve(item);
                  value.status = false;
                  return value;
                });
              },
              info: {
                title: "",
                body: "",
              },
              controllers: {
                btnClose: true,
                btn: [
                  {
                    text: "Aceptar",
                    status: false,
                    style: "btn-success",
                    value: true,
                  },
                  {
                    text: "Cancelar",
                    status: false,
                    style: "btn-secondary",
                    value: false,
                  },
                ],
                input: {
                  status: false,
                  placeholder: "",
                  value: "",
                },
              },
            };

            return value;
          });
        },
        info: {
          title: "",
          body: "",
        },
        controllers: {
          btnClose: true,
          btn: [
            {
              text: "Aceptar",
              status: false,
              style: "btn-success",
              value: true,
            },
            {
              text: "Cancelar",
              status: false,
              style: "btn-secondary",
              value: false,
            },
          ],
          input: {
            status: false,
            placeholder: "",
            value: "",
          },
        },
      },
    },
    viewOrdenar: {
      status: false,
      nav: false,
      index: [0, 0],
    },
    viewCE: {
      status: false,
      nav: false,
      inputs: [
        {
          name: "pregunta",
          active: false,
          value: "",
          old: "",
          valid: false,
          styletxt: "",
          messtxt: "",
        },
        {
          name: "tipo",
          active: false,
          value: 0,
          old: "",
          valid: false,
          styletxt: "",
          messtxt: "",
        },
        {
          name: "check",
          active: false,
          value: "",
          old: "",
          valid: false,
          styletxt: "",
          messtxt: "",
        },
        {
          name: "size",
          active: false,
          value: "",
          old: "",
          valid: false,
          styletxt: "",
          messtxt: "",
        },
        {
          name: "checks",
          active: false,
          value: [],
          old: "",
          valid: false,
          styletxt: "",
          messtxt: "",
        },
      ],
      btn: [
        {
          text: "Guardar",
          status: true,
          style: "btn-outline-primary",
          ico: "bi bi-check2-circle",
        },
        {
          text: "Editar",
          status: false,
          style: "btn-outline-primary",
          ico: "bi bi-pencil-square",
        },
        {
          text: "Cancelar",
          status: true,
          style: "btn-outline-danger",
          ico: "bi bi-x-circle",
        },
      ],
    },
    viewSondeosPanel: {
      status: false,
      nav: false,
    },
    viewPerfil: {
      status: false,
      nav: false,
      logOut: false,
    },
    viewMenu: {
      status: false,
      nav: false,
      menuService: false,
      mesa: 0,
      ind_user:false,
      servicio: {
        time: {
          status: false,
          date: "",
        },
        status: false,
      },
    },
    viewConfiguracion: {
      dataServ: [],
      status: false,
      nav: false,
      forms: {
        config: {
          btn: [
            {
              text: "Guardar",
              status: false,
              style: "btn-light",
              ico: "bi bi-check2-circle",
            },
            {
              text: "Editar",
              status: false,
              style: "btn-light",
              ico: "bi bi-pencil-square",
            },
            {
              text: "Cancelar",
              status: false,
              style: "btn-light",
              ico: "bi bi-x-circle",
            },
            {
              text: "Crear grupo de ratinggs",
              status: false,
              style: "btn-light",
              ico: "bi bi-plus-circle",
            },
          ],
          inputs: [
            {
              /* Nombre del servicio */
              active: true,
              value: "",
              valid: false,
              styletxt: "",
              messtxt: "",
            },
            {
              /* url de la imagen */
              active: true,
              value: "",
              valid: false,
              styletxt: "",
              messtxt: "",
            },
            {
              /* modo */
              active: true,
              value: "",
              valid: false,
              styletxt: "",
              messtxt: "",
            },
            {
              /* mesas */
              active: true,
              value: "",
              valid: false,
              styletxt: "",
              messtxt: "",
            },
            {
              /* mesas */
              active: true,
              value: "",
              valid: false,
              styletxt: "",
              messtxt: "",
            },
          ],
        },
        admins: {
          active: false,
          nuevo: false,
          index: 0,
          btn: [
            {
              text: "Nuevo",
              status: false,
              style: "btn-light ",
              ico: "bi bi-plus-circle",
            },
            {
              text: "Guardar",
              status: false,
              style: "btn-light",
              ico: "bi bi-check2-circle",
            },
            {
              text: "Cancelar",
              status: false,
              style: "btn-light",
              ico: "bi bi-x-circle",
            },
          ],
          inputs: [
            {
              active: true,
              value: "",
              valid: false,
              styletxt: "",
              messtxt: "",
            },
            {
              active: true,
              value: "",
              valid: false,
              styletxt: "",
              messtxt: "",
            },
          ],
        },
      },
    },
    viewMesas:{
      status: false,
      nav: false
    }

  };
}

export function getInt(v) {
  return Math.floor(Math.random() * v);
}

export const panelController = writable(dataReset());

export const viewMesas = writable({
      mesaData: [],
      doc: { data: {}, id: "", create: false },
    });

export const modalS = writable({
  status: false,
  id: 0,
  value: null,
  resolve: null,
  reject: null,
  mostrar: () => {
    modalS.update((value) => {
      value.status = true;
      return value;
    });

    return new Promise((resolve, reject) => {
      modalS.update((value) => {
        value.resolve = resolve;
        value.reject = reject;
        return value;
      });
    });
  },

  confirmar: (item) => {
    modalS.update((value) => {
      value.resolve(item);
      value.status = false;
      return value;
    });
  },
  reset: () => {
    modalS.update((value) => {
      value = {
        status: false,
        id: 0,
        value: null,
        resolve: null,
        reject: null,

        mostrar: () => {
          modalS.update((value) => {
            value.status = true;
            return value;
          });

          return new Promise((resolve, reject) => {
            modalS.update((value) => {
              value.resolve = resolve;
              value.reject = reject;
              return value;
            });
          });
        },
        reset: value.reset,
        confirmar: (item) => {
          modalS.update((value) => {
            value.resolve(item);
            value.status = false;
            return value;
          });
        },
        info: {
          title: "",
          body: "",
        },
        controllers: {
          btnClose: true,
          btn: [
            {
              text: "Aceptar",
              status: false,
              style: "btn-success",
              value: true,
            },
            {
              text: "Cancelar",
              status: false,
              style: "btn-secondary",
              value: false,
            },
          ],
          input: {
            status: false,
            placeholder: "",
            value: "",
            label: "",
          },
        },
      };

      return value;
    });
  },
  info: {
    title: "",
    body: "",
  },
  controllers: {
    btnClose: true,
    btn: [
      {
        text: "Aceptar",
        status: false,
        style: "btn-success",
        value: true,
      },
      {
        text: "Cancelar",
        status: false,
        style: "btn-secondary",
        value: false,
      },
    ],
    input: {
      status: false,
      placeholder: "",
      value: "",
      label: "",
    },
  },
});

export const viewsData = writable(false);

export function modalReset() {
  modalS.set({
    status: false,
    id: 0,
    value: null,
    resolve: null,
    reject: null,
    mostrar: () => {
      modalS.update((value) => {
        value.status = true;
        return value;
      });

      return new Promise((resolve, reject) => {
        modalS.update((value) => {
          value.resolve = resolve;
          value.reject = reject;
          return value;
        });
      });
    },

    confirmar: (item) => {
      modalS.update((value) => {
        value.resolve(item);
        value.status = false;
        return value;
      });
    },
    info: {
      title: "",
      body: "",
    },
    controllers: {
      btnClose: true,
      btn: [
        {
          text: "Aceptar",
          status: false,
          style: "btn-success",
          value: true,
        },
        {
          text: "Cancelar",
          status: false,
          style: "btn-secondary",
          value: false,
        },
      ],
      input: {
        status: false,
        placeholder: "",
        value: "",
      },
    },
  });
};

export const dropDoc = async (data) => {
  let doc = { status: true, error: "" };
  try {
    await db.collection(data.collection).doc(data.id).delete();
    doc = { status: true, error: "" };
    return doc;
  } catch (error) {
    doc = { status: false, error: error };
    return doc;
  }
};

export function validText(opc, value) {
  let ep;
  switch (opc) {
    case 0:
      ep = /^[0-50\w'\-,.][^_!¡?÷?¿/\\+=@#$%ˆ&*(){}|~<>;:[\]]{2,50}$/;
      break;
    case 1:
      ep =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      break;
    default:
      break;
  }
  if (ep.test(value)) {
    return true;
  } else {
    return false;
  }
};

export const addDoc = async (data) => {
  let doc = { ref: "", status: true, error: "" };
  try {
    doc.ref = await db.collection(data.collection).add(data.data);
    return doc;
  } catch (error) {
    doc = { error: error, status: false };
    return doc;
  }
  return await doc;
};

export async function updateD(data) {
  let doc = { ref: "", status: true, error: "" };
  try {
    const mesaRef = db.collection(data.collection).doc(data.id);
    await mesaRef.update(data.data);
    /* proces200(); */
  } catch (error) {
    doc = { error: error, status: false };
  }
  return await doc;
}

export const searchDoc = async (data) => {
  let doc = { data: [], status: true, error: "" };
  await db
    .collection(data.collection)
    .where(data.data[0], data.data[1], data.data[2])
    .get()
    .then((querySnapshot) => {
      let dat = [];
      querySnapshot.forEach((doc) => {
        dat.push({ doc: doc.data(), id: doc.id });
        /* console.log(doc.id); */
        
      });
      
      
      if (dat.length === 0) {
        doc = { error: "No existe", status: false };
      } else {
        doc.data = dat;
      }
    })

    .catch((error) => {
      doc = { error: error, status: false };
    });

  return doc;
};

export const btntodook = writable(true);
export const segundosStore = writable(0); // Store para el valor de los segundos
export const intervalIdStore = writable(null); // Store para el ID del intervalo
export const modalStore = writable({
  open: false,
  title: "Aviso",
  body: " ¿Estaría interesado en participar en una encuesta más detallada?",
  ans: null,
  opc: null,
  data: [],
  opcN: "No",
  opcS: "Si, quiero",
  mess: true,
  form: {
    active: false,
    placeholder: "",
    value: "",
  },
});

export function modalSReset() {
  modalS.set({
    status: false,
    id: 0,
    value: null,
    info: {
      title: "",
      body: "",
    },
    controllers: {
      btnClose: true,
      btn: [
        {
          text: "Aceptar",
          status: false,
          style: "btn-success",
          value: true,
        },
        {
          text: "Cancelar",
          status: false,
          style: "btn-secondary",
          value: false,
        },
      ],
      input: {
        status: false,
        placeholder: "",
        value: "",
      },
    },
  });
};

export const fxModalconfirm = (data) => {
  modalStore.set({
    title: data.title,
    ans: null,
    opc: 0,
    opcN: data.opcN,
    body: data.body,
    opcS: data.opcS,
    mess: true,
    form: {
      active: true,
      placeholder: data.placeholder,
      value: "",
    },
    open: true,
  });
};

export const dataEdit = writable({
  data: {},
  opc: null,
});

let intervalId;

export function error404() {
  modalStore.set({
    title: "Aviso",
    ans: null,
    opc: 404,
    opcN: "No",
    body: "Error en el servidor.",
    opcS: "Aceptar",
    mess: false,
    open: true,
    form: false,
  });
}

export function proces200() {
  modalStore.set({
    title: "Aviso",
    ans: null,
    opc: 200,
    opcN: "No",
    body: "Operación realizado con éxito.",
    opcS: "Aceptar",
    mess: false,
    open: true,
    form: false,
  });
}

export function proces401() {
  modalStore.set({
    title: "Aviso",
    ans: null,
    opc: 401,
    opcN: "No",
    body: "No se encontró ningún registro.",
    opcS: "Aceptar",
    mess: false,
    open: true,
    form: false,
  });
}

export function messrest() {
  modalStore.set({
    title: "Aviso",
    ans: null,
    opc: 0,
    opcN: "",
    body: "",
    opcS: "",
    mess: false,
    open: false,
  });
}

export async function br(item) {
  let data;
  await db
    .collection(item.collection)
    .where(item.data, item.filter, item.value)
    .get()
    .then((querySnapshot) => {
      querySnapshot.forEach((doc) => {
        // doc.data() is never undefined for query doc snapshots
        data = { id: doc.id, ...doc.data() };
      });
    })
    .catch((error) => {
      error404();
    });
  if (data === undefined) {
    return false;
  } else {
    return data;
  }
}

export function bd(item) {
  // Obtiene la referencia al documento usando el ID
  try {
    const documentoRef = db.collection(item.collection).doc(item.id);
    documentoRef.get().then((doc) => {
      if (doc.exists) {
        data = { id: doc.id, ...doc.data() };
      } else {
        data = { status: 404 };
      }
    });
    /*  document.set(data) */
  } catch (error) {
    console.error("Error al obtener el documento:", error);
  }

  db.collection("config")
    .where("admins.email", "==", "marcelobautista994@gmail.com")
    .get()
    .then((querySnapshot) => {
      querySnapshot.forEach((doc) => {});
    })
    .catch((error) => {
      console.error("Error al buscar el documento:", error);
    });
}

export function rd(item) {
  let data;
  try {
    db.collection(item.name).onSnapshot((querySnapshot) => {
      querySnapshot.forEach((doc) => {
        data = { id: doc.id, ...doc.data() };
      });
      document.set(data);
    });
    return data;
    // Actualiza el almacén con el arreglo de config
  } catch (error) {
    console.error(error);
  }
}

export function iniciarConteo(nMes) {
  intervalId = setInterval(() => {
    segundosStore.update((value) => value + 1);
  }, 1000);
  intervalIdStore.set(intervalId);
}

export function detenerConteo(nMes) {
  clearInterval(intervalId);
}

export function reiniciarConteo() {
  detenerConteo();
  segundosStore.set(0);
}

export function reiniciarOtroConteo(arraySeleccion) {
  detenerConteo();
  segundosStore.set(0);
  btntodook.set(true);
  iniciarConteo(arraySeleccion);
}

export function cambiarconfig() {
  nconfig.set(0);
  reiniciarConteo();
}

export async function updateModal(modal) {
  let configIndex = modal.dataList.config.findIndex(
    (config) => config.nconfig === modal.data
  );

  if (configIndex !== -1) {
    const dataL = {
      id: modal.dataList.id,
      config: modal.dataList.config,
    };
    switch (modal.ans) {
      case 1:
        dataL.config[configIndex].estado = false;
        dataL.config[configIndex].cuenta = false;
        dataL.config[configIndex].time_service = "";

        break;
      case 2:
        dataL.config[configIndex].estado = null;
        dataL.config[configIndex].cuenta = null;
        dataL.config[configIndex].time_service = "";
        dataL.config[configIndex].photoURL = "";
        dataL.config[configIndex].displayName = "";
        delete dataL.config[configIndex].time;

        break;
      case 3:
        dataL.config[configIndex].estado = null;
        dataL.config[configIndex].cuenta = null;
        dataL.config[configIndex].time_service = "";
        dataL.config[configIndex].photoURL = "";
        dataL.config[configIndex].displayName = "";
        delete dataL.config[configIndex].time;

        break;
      default:
        break;
    }

    /* serviceconfig(dataL); */
  }
}

export async function serviceconfig(data) {
  try {
    const configRef = db.collection("config").doc(data.id);
    await configRef.update({ config: data.config });
  } catch (error) {
    error404();
    console.error("Error al actualizar el estado de la config:", error);
  }
}